import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import DramaCard from "@/components/base/DramaCard";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import QuickLinks from "./components/QuickLinks";
import NewsSection from "./components/NewsSection";
import TopicSection from "./components/TopicSection";
import { allDramas } from "@/utils/content";

const featured = [...allDramas].sort((a, b) => b.popularity - a.popularity).slice(0, 4);
const popular = [...allDramas].sort((a, b) => b.popularity - a.popularity).slice(0, 8);

const STATS = [
  { value: "500+", label: "收录影视剧" },
  { value: "300+", label: "演员资料" },
  { value: "每日", label: "更新资讯" },
  { value: "30+", label: "精选专题" },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-100">
      <SiteHeader />
      <main>
        <HeroCarousel featured={featured} />
        <QuickLinks />

        <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <SectionHeading
            eyebrow="热力榜单"
            title="热门影视推荐"
            description="根据剧集热度与观众口碑为你挑选，点开就能看到完整剧情与演员阵容。"
            action={{ label: "全部影视", to: "/category" }}
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
            {popular.map((drama) => (
              <DramaCard key={drama.id} drama={drama} />
            ))}
          </div>
        </section>

        <NewsSection />
        <TopicSection />

        <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 mb-4">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                关于隔壁的女孩
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                把每一部好剧，讲给你听
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
                「隔壁的女孩」是一个专注于影视资讯与剧情解析的内容网站。我们记录最新上线的电影、电视剧与网剧，
                用通俗的语言梳理剧情脉络，整理演员资料与作品清单，帮你在海量内容里快速找到想看的那一部。
              </p>
              <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
                {STATS.map((stat) => (
                  <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                    <p className="font-heading text-xl md:text-2xl font-bold text-accent-600">{stat.value}</p>
                    <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
              <Link
                to="/about"
                className="mt-7 inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="w-full aspect-[16/11] overflow-hidden rounded-lg border border-background-200 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=cozy%20modern%20living%20room%20with%20large%20screen%20movie%20wall%2C%20warm%20ambient%20lighting%2C%20deep%20navy%20and%20cream%20interior%20with%20soft%20orange%20glow%2C%20cinematic%20editorial%20photography%20style%2C%20inviting%20atmosphere%2C%20no%20text&width=1200&height=820&seq=home-about-intro&orientation=landscape"
                alt="在家舒适追剧的客厅场景"
                title="隔壁的女孩 影视资讯与剧情介绍"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}